import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import Button from '@salesforce/design-system-react/components/button';
import { BrowserRouter as Router, RouteComponentProps, withRouter } from 'react-router-dom';
import AgencyTransaction from '../../Shared/AgencyTransaction';

interface EventId {
  caseExternalId: string;
  eventId: string;
  caseNumber: string;
  orderId: string;
  isAgencyRecord: boolean;
}

// interface for props that the data table cell is getting default from data table.
export interface Props extends RouteComponentProps {
  children?: FC;
  item?: EventId;
  type?: string;
}

const OrderRequestIdCell: FC<Props> = ({
  item = {
    caseExternalId: null,
    orderId: null,
    eventId: null,
    caseNumber: null,
    isAgencyRecord: false,
  },
  history,
  type = null,
}) => {
  const { eventId, caseNumber, caseExternalId, orderId, isAgencyRecord } = item;
  const goToOrderDetails = (): void => {
    if (type === 'Favorites') {
      history.push('/inventoryFavoriteDetails', {
        inventoryRequestFav: item,
      });
    } else if (type === 'Processed' || type === 'Failed') {
      history.push('/inventoryRequestDetails', {
        isEventInventoryFlow: false,
        externalId: orderId || caseExternalId,
        type: orderId ? type : 'Open',
      });
    } else if (type === 'Open') {
      history.push('/inventoryRequestDetails', {
        isEventInventoryFlow: false,
        externalId: caseExternalId,
        type,
      });
    }
  };

  return (
    <Router>
      <DataTableCell title={eventId || ''}>
        <>
          <AgencyTransaction isAgencyRecord={isAgencyRecord} />
          <Button
            style={{ margin: '5px 5px 5px 5px' }}
            label={eventId || caseNumber || 'TBD'}
            variant="base"
            onClick={goToOrderDetails}
          />
        </>
      </DataTableCell>
    </Router>
  );
};

export default withRouter(OrderRequestIdCell);
